import Env from '../base/env'
import gsap from 'gsap'
import easesCustom from '../fx/CustomEases';

export default class MainTransition
{
    constructor()
    {
      this.DOM = {}
      this.DOM.view = document.getElementById('transitionView')
      this.DOM.fillA = document.querySelector('.fxFillA')
      this.DOM.fillB = document.querySelector('.fxFillB')
      this.DOM.fills = document.querySelectorAll('.fxFill')
      this.DOM.logo = this.DOM.view.querySelector('.fxLogo')
      this.settings = { easing : 'quint.out' , duration : .4 }
      this.direction = false
      this.status = false

    }

    getStatus()
    {
        return this.status
    }

    out(funcStart='',funcComplete='')
    {

      let tl = gsap.timeline({
        onStart:()=>{
          this.status = 'animating'
          if(typeof funcStart == 'function' || funcStart != null) funcStart()
        },
        onComplete:()=>{
          this.status = 'in'
          if(typeof funcComplete == 'function' || funcComplete != null) funcComplete()
        }
      })

      tl
      .add(()=>{
        gsap.set(this.DOM.view,{ autoAlpha:1 })
      })
      .add([
        gsap.fromTo(
          this.DOM.fills,
          {
            clipPath:'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)',
          },
          {
            clipPath:'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
            ease: 'quint.in',
            duration:1.3,
            stagger:.1
          }
        )
      ]).add([
        gsap.fromTo(
          this.DOM.logo.querySelectorAll('path'),
          {
            autoAlpha:0
          },
          {
            autoAlpha:1,
            duration:1,
            ease:'cubic.inOut',
            stagger:.01
          }
        )
      ],'-=.2')
    }

    in(funcStart='',funcComplete='')
    {
      let tl = gsap.timeline({
        onStart:()=>{
            this.status = 'animating'
            if(typeof funcStart == 'function' || funcStart != null) funcStart()
        },
        onComplete:()=>{
          console.log('transi in end');
            this.status = 'out'
            if(typeof funcComplete == 'function' || funcComplete != null) funcComplete()
        }
      })

      tl
      .add([
        gsap.fromTo(
          this.DOM.fills,
          {
            clipPath:'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
          },
          {

            clipPath:'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)',
            ease: 'quint.out',
            duration:1,
            stagger:-.1
          }
        ),
      ])
      .add(()=>{
        gsap.set(this.DOM.view,{ autoAlpha:0 })
      })
    }

}
